module.exports = "<p>\r\n  news-blog works!\r\n</p>\r\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/components/blog/news-blog/news-blog.component.html
// module id = ./src/app/components/blog/news-blog/news-blog.component.html
// module chunks = main